export var DataLayerEventType;
(function (DataLayerEventType) {
    DataLayerEventType["ExperienceImpression"] = "ExperienceImpressionEvent";
    DataLayerEventType["FacetClearAll"] = "FacetClearAll";
    DataLayerEventType["FacetRemoved"] = "FacetRemoved";
    DataLayerEventType["FacetSelected"] = "FacetSelected";
    DataLayerEventType["FacetOpen"] = "FacetOpen";
    DataLayerEventType["FacetClose"] = "FacetClose";
    DataLayerEventType["MatchingAvailability"] = "MatchingAvailability";
    DataLayerEventType["PaginationClick"] = "PaginationClick";
    DataLayerEventType["PropertyClick"] = "PropertyClick";
    DataLayerEventType["PropertyBook"] = "PropertyBook";
    DataLayerEventType["PropertyPageView"] = "PropertyPageView";
    DataLayerEventType["SearchPageView"] = "SearchPageView";
    DataLayerEventType["SearchSubmit"] = "SearchSubmit";
    DataLayerEventType["SearchStart"] = "SearchStart";
    DataLayerEventType["ServicesSearchSubmit"] = "ServicesSearchSubmit";
    DataLayerEventType["SitePageView"] = "SitePageView";
    DataLayerEventType["SearchNoResults"] = "SearchNoResults";
    DataLayerEventType["MapProductClick"] = "MapProductClick";
    DataLayerEventType["MapProductImpression"] = "MapProductImpression";
    DataLayerEventType["MapView"] = "MapView";
    DataLayerEventType["MapViewFail"] = "MapViewFail";
    DataLayerEventType["SwitchToMap"] = "SwitchToMap";
    DataLayerEventType["SwitchToList"] = "SwitchToList";
})(DataLayerEventType || (DataLayerEventType = {}));
export var TmsEventType;
(function (TmsEventType) {
    TmsEventType["link"] = "link";
    TmsEventType["view"] = "view";
})(TmsEventType || (TmsEventType = {}));
//# sourceMappingURL=DataLayer.types.js.map